import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { environment } from "../../environments/environment";
import { createBrowserHistory } from "history";
import { ComponentType } from "react";

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

const appInsightsInstance = new ApplicationInsights({
    config: {
        connectionString: environment.APPLICATIONINSIGHTS_CONNECTION_STRING,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory } // Automatically track route changes
        }
    }
});

appInsightsInstance.loadAppInsights();


export const appInsights = appInsightsInstance; // Export the ApplicationInsights instance
const withNoopTracking = (Component: ComponentType<unknown>) => Component; // Return component as-is without tracking
export default withNoopTracking;